import { render, staticRenderFns } from "./standard-dropdown-list.vue?vue&type=template&id=4df7efa0&scoped=true"
import script from "./standard-dropdown-list.vue?vue&type=script&lang=js"
export * from "./standard-dropdown-list.vue?vue&type=script&lang=js"
import style0 from "./standard-dropdown-list.vue?vue&type=style&index=0&id=4df7efa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7efa0",
  null
  
)

export default component.exports